module.exports = __webpack_public_path__ + "static/media/choithramsTataSaltS.5e1a311d.png";